<div nxLayout="grid" style="z-index: 2;" >
  <div class="header-container" nxRow style="justify-content: center; display: none;">
    <app-header class="container1120 app-header-wrapper"></app-header>
  </div>
</div>
<ng-container *ngIf="!sharedService.loadingStep">
  <ng-container *ngIf="{
      propertyCategories: sharedService.$propertyCategories | async,
      productTypes: sharedService.productTypes$ | async,
      additionalInfo: sharedService.additionalInfo$ | async,
      currency: sharedService.getCurrency() | async
       } as o">
  </ng-container>

 <div class="container-wrapper"> 
    <div class="wrapper" nxLayout="grid">
      <router-outlet (activate)="onActivate($event)" #outlet></router-outlet>

    </div>
  </div>
</ng-container>
<ng-container *ngIf="sharedService.loadingStep">
  <div class="wrapper loading" nxLayout="grid">
    <app-loading></app-loading>
  </div>
</ng-container>
<ng-container *ngIf="sharedService.loadingSpinner">
  <div class="backdrop loading" nxLayout="grid">
    <app-loading></app-loading>
  </div>
</ng-container>

